/**
 * Обвязка формы подтверждения телефона (#phone-confirm, макет pv-ms-).
 * Разметка: include/popups/(ru|en)/phone_confirm.php, стили: css/phone-confirm.css.
 *
 * Отправку ПЕРВОГО кода делает вызывающая форма (она же берёт токен капчи и
 * шлёт его в itpragma:kupper.Auth.sendCode) — попап получает masked/resendInterval
 * и ведёт ввод кода, повтор и проверку ЕДИНЫМИ экшенами модуля itpragma.kupper:
 *   auth   → itpragma:kupper.Auth.resendCode / verifyCode (вход, гарантия, «1 клик»)
 *   verify → itpragma:kupper.PhoneVerify.resendCode / verifyCode (чекаут)
 * Разница: auth по подтверждению авторизует владельца номера, verify только
 * ставит отметку владения в сессии — гостю чекаута логиниться незачем.
 * Ветки change нет: смены номера в ЛК monsher не существует.
 * Повтор — без капчи (защита лимитами), таймер ведётся ТОЛЬКО от resendInterval
 * из ответов сервера.
 *
 * window.msPhoneConfirm.open({
 *   scenario: 'auth' | 'verify',
 *   phone: '+79991234567',   // сырой номер
 *   masked: '+7 999 999-99-99',
 *   resendInterval: 60,
 *   message: '',             // channelMessage из ответа отправки
 *   skipSuccess: true,       // без экрана успеха: закрыть и сразу onSuccess
 *   onSuccess: function (data) {},  // подтверждено (data — ответ verifyCode)
 *   onBack: function () {}          // «Назад» / «Ввести другой номер»
 * });
 */
const msPhoneConfirm = (function () {
    const ENDPOINTS = {
        auth: { controller: 'Auth', byPhone: true },
        verify: { controller: 'PhoneVerify', byPhone: true }
    };

    const TEXTS = {
        ru: {
            leadResent: 'Отправили код ещё раз — обычной SMS, на номер ',
            errorCommon: 'Что-то пошло не так. Попробуйте ещё раз.',
            errorShortCode: 'Введите 4 цифры кода',
            checking: 'Проверяем…',
            confirm: 'Подтвердить',
            successAuth: 'Вы авторизованы',
            successRegistered: 'Регистрация завершена',
            successVerified: 'Номер подтверждён',
            successAccountCreated: 'Личный кабинет создан — заявка сохранится в нём.'
        },
        en: {
            leadResent: 'We sent the code again — by regular SMS, to ',
            errorCommon: 'Something went wrong. Please try again.',
            errorShortCode: 'Enter the 4-digit code',
            checking: 'Checking…',
            confirm: 'Confirm',
            successAuth: 'You are logged in',
            successRegistered: 'Registration completed',
            successVerified: 'Number confirmed',
            successAccountCreated: 'An account has been created — your request will be saved there.'
        }
    };

    let state = null;

    function t(key) {
        const lang = window.lang === 'en' ? 'en' : 'ru';
        return TEXTS[lang][key];
    }

    function modalEl() {
        return document.querySelector('[data-modal="#phone-confirm"]');
    }

    function q(sel) {
        return state ? state.modal.querySelector(sel) : null;
    }

    function inputs() {
        return Array.prototype.slice.call(state.modal.querySelectorAll('.pv-ms-code__input'));
    }

    function callAction(action, params) {
        const cfg = ENDPOINTS[state.opts.scenario];
        const body = new FormData();

        body.append('sessid', BX.bitrix_sessid());
        if (cfg.byPhone) {
            body.append('phone', state.opts.phone || '');
        }
        Object.keys(params || {}).forEach(function (key) {
            body.append(key, params[key]);
        });

        return fetch('/bitrix/services/main/ajax.php?action=itpragma:kupper.' + cfg.controller + '.' + action, {
            method: 'POST',
            body: body,
            credentials: 'same-origin'
        }).then(function (response) {
            return response.json();
        });
    }

    function firstError(response) {
        if (response && response.errors && response.errors.length && response.errors[0].message) {
            return response.errors[0].message;
        }
        return t('errorCommon');
    }

    function showWindow(name) {
        state.modal.querySelectorAll('[data-pv-window]').forEach(function (win) {
            win.classList.toggle('pv-ms__window--active', win.dataset.pvWindow === name);
        });
    }

    function clearError() {
        const error = q('[data-pv-error]');
        const code = q('[data-pv-code]');

        if (error) error.hidden = true;
        if (code) code.classList.remove('pv-ms-code--error', 'pv-ms-code--shake');
    }

    function showError(message) {
        const error = q('[data-pv-error]');
        const code = q('[data-pv-code]');

        if (error) {
            error.textContent = message;
            error.hidden = false;
        }
        if (code) {
            code.classList.remove('pv-ms-code--shake');
            void code.offsetWidth;
            code.classList.add('pv-ms-code--error', 'pv-ms-code--shake');
        }
    }

    function resetInputs() {
        inputs().forEach(function (input) {
            input.value = '';
        });
    }

    function startTimer(seconds) {
        stopTimer();

        const wrap = q('[data-pv-timer-wrap]');
        const counter = q('[data-pv-timer]');
        const resendBtn = q('[data-pv-resend]');
        let left = Math.max(1, Math.ceil(seconds || 60));

        if (!wrap || !counter || !resendBtn) return;

        resendBtn.hidden = true;
        wrap.hidden = false;
        counter.textContent = left;

        state.timerId = setInterval(function () {
            left -= 1;

            if (left > 0) {
                counter.textContent = left;
                return;
            }

            stopTimer();
            wrap.hidden = true;
            resendBtn.hidden = false;
        }, 1000);
    }

    function stopTimer() {
        if (state && state.timerId) {
            clearInterval(state.timerId);
            state.timerId = null;
        }
    }

    function resend() {
        if (state.busy) return;
        state.busy = true;
        clearError();

        callAction('resendCode', {}).then(function (response) {
            state.busy = false;

            if (response.status === 'success' && response.data) {
                const lead = q('[data-pv-lead]');
                if (lead && response.data.channelMessage) {
                    lead.innerHTML = '';
                    lead.appendChild(document.createTextNode(t('leadResent')));
                    const bold = document.createElement('b');
                    bold.textContent = response.data.masked || state.opts.masked || '';
                    lead.appendChild(bold);
                }
                startTimer(response.data.resendInterval || state.opts.resendInterval);
                inputs()[0].focus();
                return;
            }

            showError(firstError(response));
            startTimer(state.opts.resendInterval);
        }).catch(function () {
            state.busy = false;
            showError(t('errorCommon'));
            startTimer(state.opts.resendInterval);
        });
    }

    function submit() {
        const code = inputs().map(function (input) { return input.value; }).join('');
        const button = q('[data-pv-submit]');

        if (state.busy) return;
        if (code.length < 4) {
            showError(t('errorShortCode'));
            return;
        }

        state.busy = true;
        clearError();
        if (button) {
            button.disabled = true;
            button.textContent = t('checking');
        }

        callAction('verifyCode', { code: code }).then(function (response) {
            state.busy = false;
            if (button) {
                button.disabled = false;
                button.textContent = t('confirm');
            }

            if (response.status === 'success' && response.data && response.data.confirmed) {
                showSuccess(response.data);
                return;
            }

            showError(firstError(response));
            inputs()[0].select();
        }).catch(function () {
            state.busy = false;
            if (button) {
                button.disabled = false;
                button.textContent = t('confirm');
            }
            showError(t('errorCommon'));
        });
    }

    function showSuccess(data) {
        const opts = state.opts;
        const title = q('[data-pv-success-title]');
        const text = q('[data-pv-success-text]');

        stopTimer();

        // Сценарию вроде «1 клика» экран успеха только мешает: заказ должен
        // уйти сразу после сверки кода, как делал прежний попап lk-auth-confirm.
        if (opts.skipSuccess) {
            state.finished = true;
            const onSuccess = opts.onSuccess;
            close();
            if (typeof onSuccess === 'function') {
                onSuccess(data);
            }
            return;
        }

        if (title) {
            // Заголовок — по действию человека, а не по тому, что случилось внутри.
            // verify никого не авторизует, а keepPage означает форму, которая пришла
            // за подтверждением номера (гарантия): «Вы авторизованы» там сбивает
            // с толку — вход был средством, а не целью.
            title.textContent = (opts.scenario === 'verify' || opts.keepPage)
                ? t('successVerified')
                : (data.is_new ? t('successRegistered') : t('successAuth'));
        }
        if (text) {
            text.textContent = opts.keepPage && data.is_new ? t('successAccountCreated') : '';
        }

        showWindow('success');

        const finish = function () {
            if (!state || state.finished) return;
            state.finished = true;

            const onSuccess = opts.onSuccess;
            close();
            if (typeof onSuccess === 'function') {
                onSuccess(data);
            }
        };

        const done = q('[data-pv-done]');
        if (done) {
            done.addEventListener('click', finish);
        }
        // Экран успеха — подтверждение глазами; сценарий продолжается сам.
        setTimeout(finish, 1200);
    }

    function goBack(event) {
        if (event) event.preventDefault();

        const onBack = state && state.opts.onBack;
        close();
        if (typeof onBack === 'function') {
            onBack();
        }
    }

    function bind() {
        const fields = inputs();

        state.cleanups = [];

        const on = function (el, type, handler) {
            if (!el) return;
            el.addEventListener(type, handler);
            state.cleanups.push(function () {
                el.removeEventListener(type, handler);
            });
        };

        fields.forEach(function (input, index) {
            on(input, 'input', function () {
                clearError();
                input.value = input.value.replace(/\D/g, '').slice(0, 1);

                if (input.value !== '' && index < fields.length - 1) {
                    fields[index + 1].focus();
                }
                if (fields.every(function (field) { return field.value !== ''; })) {
                    submit();
                }
            });

            on(input, 'keydown', function (event) {
                if (event.key === 'Backspace' && input.value === '' && index > 0) {
                    fields[index - 1].focus();
                    fields[index - 1].value = '';
                    event.preventDefault();
                }
            });

            on(input, 'paste', function (event) {
                const textData = (event.clipboardData || window.clipboardData).getData('text') || '';
                const digits = textData.replace(/\D/g, '').slice(0, fields.length);

                if (!digits.length) return;
                event.preventDefault();
                clearError();
                fields.forEach(function (field, i) {
                    field.value = digits[i] || '';
                });
                fields[Math.min(digits.length, fields.length) - 1].focus();
                if (digits.length === fields.length) {
                    submit();
                }
            });
        });

        on(q('[data-pv-submit]'), 'click', submit);
        on(q('[data-pv-resend]'), 'click', function (event) {
            event.preventDefault();
            resend();
        });
        on(q('[data-pv-back]'), 'click', goBack);
        on(q('[data-pv-another]'), 'click', goBack);

        // Закрытие крестиком/оверлеем: приберём таймер и обработчики.
        on(state.modal, 'closemodal', teardown);
    }

    function teardown() {
        if (!state) return;

        stopTimer();
        (state.cleanups || []).forEach(function (cleanup) {
            cleanup();
        });
        resetInputs();
        clearError();
        showWindow('main');
        state = null;
    }

    function close() {
        if (!state) return;
        modals.closeModal(null, '#phone-confirm');
        // closemodal-событие вызовет teardown(); подстрахуемся на случай,
        // если модалка уже была закрыта.
        teardown();
    }

    function open(opts) {
        const modal = modalEl();

        if (!modal || !ENDPOINTS[(opts || {}).scenario]) return;

        teardown();

        modals.openModal(null, '#phone-confirm', function () {
            state = { opts: opts, modal: modal, timerId: null, busy: false, finished: false, cleanups: [] };

            const phoneNode = modal.querySelector('[data-pv-phone]');
            if (phoneNode) {
                phoneNode.textContent = opts.masked || opts.phone || '';
            }

            showWindow('main');
            bind();
            startTimer(opts.resendInterval);
            inputs()[0].focus();
        });
    }

    return {
        open: open,
        close: close,
        isOpen: function () {
            return state !== null;
        }
    };
})();

window.msPhoneConfirm = msPhoneConfirm;
